export const selectCategoryPages = (state: any) =>
  state.getIn(['preFetchedData', 'categoryPages', 'data']) || [];
